import { Fragment } from 'react';
import classNames from 'classnames';
import { Link } from '@hc/redux-saga-router-plus';
import { Button } from 'legacy/components/Button';
import { NullStateCard } from '@hc/component-lib/hclib/components/molecules/null-state-card';

import CompsMapContainer from 'legacy/containers/maps-comps';

import PropertyExplorerSectionHeading from 'legacy/components/PropertyExplorerSectionHeading';
import IconButton from 'legacy/components/generic/IconButton';
import CompsProperties from 'legacy/components/CompsProperties';
import GlossaryButton from 'legacy/components/GlossaryButton';
import Loading from 'legacy/components/generic/Loading';

import downloadIcon from 'legacy/assets/svg-inline/download-section.svg';

import { CompsSummarySection as theme } from 'legacy/css-modules';

const CompsSummarySection = ({
  title = 'Comparable Properties',
  addressIds,
  isLoading,
  isExcelDownloadAllowed,
  message,
  buttonLabel,
  compType,
  isReportEditable,
  isLoadedInitial,
  isLoaded,
  isError,
  onClickInfo,
  onClickDownload,
  onClickChooseComps,
  dataHcNames,
  buttonView,
  hideCTA
}) => {
  return (
    <section data-hc-name={dataHcNames.section} className={theme['component']}>
      {isError ? (
        <NullStateCard theme={theme} title="Comps Unavailable">
          Try refreshing the page to re-fetch comps. Please contact support if
          the problem persists.
        </NullStateCard>
      ) : (
        <Fragment>
          <header className={classNames(theme['header'], 'heading-section')}>
            <PropertyExplorerSectionHeading dataHcName={dataHcNames.header}>
              {title}
              {isExcelDownloadAllowed && (
                <IconButton
                  icon={downloadIcon}
                  onClick={onClickDownload}
                  disabled={!isLoaded}
                />
              )}
            </PropertyExplorerSectionHeading>
            {!!addressIds.length && (
              <div
                className={theme['message-bar']}
                data-hc-name="comps-message-bar"
              >
                <span className="comps-summary--message-bar-text">
                  {message}
                </span>
                <GlossaryButton onClick={onClickInfo} />
              </div>
            )}
          </header>
          <div
            className={classNames(
              'comps-summary--map-container',
              theme['map-container'],
              {
                'report-not-editable': !isReportEditable
              }
            )}
          >
            <Loading
              className={theme.Loading}
              loading={!isLoadedInitial}
              overlay
            >
              <CompsMapContainer
                compType={compType}
                disableScrollZoom
                isHidingControls
                disableMobileMarkerPopup
              />
            </Loading>
          </div>
          <CompsProperties
            addressIds={addressIds}
            compType={compType}
            dataHcNames={dataHcNames}
          />
          {!hideCTA && isLoadedInitial && (
            <div
              className="comps-summary--button-row"
              data-hc-name={dataHcNames.button}
            >
              <Link
                view={buttonView}
                onClick={onClickChooseComps}
                options={{ inherit: true }}
              >
                <Button primary>{buttonLabel}</Button>
              </Link>
            </div>
          )}
        </Fragment>
      )}
    </section>
  );
};

export default CompsSummarySection;
